import { LISTA_ROTAS, SELECIONAR_ROTA, LISTAR_TODAS_TAGS, GET_ROTA_USE,LISTAR_GRUPOS } from './mutation-types'

export default {
  [LISTA_ROTAS]: (state, rotas) => {
    state.rotas = rotas
  },
  [SELECIONAR_ROTA]: (state, rotaSelecionada) => {
    state.rotaSelecionada = rotaSelecionada
  },
  [LISTAR_TODAS_TAGS]: (state, tags) => {
    state.tags = tags
  },
  [GET_ROTA_USE]: (state, rotaUse) => {
    state.rotaUse = rotaUse
  },
  [LISTAR_GRUPOS]: (state, gruposRotas) => {
    state.gruposRotas = gruposRotas
  }
}
